import React from 'react';
import Header from '../components/resuableComponents/Header';
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import banner from '../assets/banner.png';
import ShoppingCard from '../components/resuableComponents/ShoppingCard';

const LandingPage = () => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('md'));
	return (
		<>
			{matches ? (
				<>
					<Header />
					<div className='homeBanner'>
						<img className='homeBannerimg' src={banner} />
					</div>
					<div
						style={{
							display: 'flex',
							padding: 4,
							overflowX: 'auto',
							gap: 10,
							whiteSpace: 'nowrap',
							// width: '100%', // Ensure it takes up only available space
							scrollbarWidth: 'none', // Hide scrollbar in Firefox
							msOverflowStyle: 'none', // Hide scrollbar in IE/Edge
							top: '-30px',
							position: 'relative',
						}}>
						<div style={{ display: 'flex', gap: 10 }}>
							<ShoppingCard />
							<ShoppingCard />
							<ShoppingCard />
							<ShoppingCard />
						</div>
					</div>
					<div
						style={{
							background: '#232f3e',
							paddingLeft: 10,
							paddingRight: 10,
						}}>
						<Grid container spacing={2}>
							<Grid item xs={6}>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>Amazon.com</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>Your Lists</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>
										Registry & Gift List
									</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>Your Account</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>
										Sell Product on Amazon
									</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>
										Recalls and Product Saftey Alerts
									</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>
										Customer Service
									</p>
								</Box>
							</Grid>
							<Grid item xs={6}>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>Your Orders</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>Gift Cards</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>Find a Gift</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>
										Browsing History
									</p>
								</Box>
								<Box>
									<p style={{ color: '#fff', fontSize: 14 }}>Your Returns</p>
								</Box>
							</Grid>
						</Grid>
					</div>
				</>
			) : (
				''
			)}
		</>
	);
};

export default LandingPage;
